import { postJson, postFormData } from './apiClient';

export type ChatResultItem = {
  type:
    | 'rfq' | 'vendor' | 'client' | 'quotation' | 'confirmed_order'
    | 'vendor_invoice' | 'client_invoice' | 'inventory' | 'email'
    | 'vendor_po' | 'payable';
  id: string;
  title: string;
  subtitle?: string;
  badge?: string;
  link?: string;
};

export type ChatCard = { label: string; value: string | number; sub?: string };
export type ChatBreakdown = { label: string; count?: number; outstanding?: string; total?: string };

export type ChatResponse = {
  reply: string;
  intent?: string;
  results?: ChatResultItem[];
  cards?: ChatCard[];
  breakdown?: ChatBreakdown[];
};

export type ChatHistoryItem = { role: 'user' | 'assistant'; text: string };

export async function sendChatMessage(message: string, history: ChatHistoryItem[] = []) {
  return postJson<ChatResponse>('/chat/message', { message, history });
}

export async function uploadChatFile(message: string, file: File) {
  const fd = new FormData();
  fd.append('file', file);
  if (message) fd.append('message', message);
  return postFormData<ChatResponse>('/chat/upload', fd);
}
